import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

type RecaptchaV2ChallengeProps = {
  visible: boolean;
  renderV2Widget: (container: HTMLElement) => Promise<void>;
};

/** Shared reCAPTCHA v2 challenge widget — renders when v3 score is too low. */
export function RecaptchaV2Challenge({ visible, renderV2Widget }: RecaptchaV2ChallengeProps) {
  const v2ContainerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (visible && v2ContainerRef.current) {
      renderV2Widget(v2ContainerRef.current);
    }
  }, [visible, renderV2Widget]);

  if (!visible) return null;

  return (
    <div data-testid="recaptcha-v2-challenge" className="space-y-3">
      <p className="text-center text-sm text-muted-foreground">
        {t('Please complete the verification to continue.')}
      </p>
      <div ref={v2ContainerRef} className="flex justify-center" />
    </div>
  );
}
